
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { 
  CorrectAnswerOVO, 
  ExplanationOVO,
  RecommendationIVO,
  MemoIVO,
  MemoOVO } from '@/views/biz/omr/vo/Omr.vo'
import axios from 'axios'

@Component
export default class ExplanationDialog extends Vue {
  @Prop() explanation !: CorrectAnswerOVO;
  @Prop() isTab !: boolean;

  dialogTab = 0;
  // 풀이
  explanations: Array<ExplanationOVO> = [] as Array<ExplanationOVO>;
  // 메모
  memo: MemoOVO = {} as MemoOVO;

  closeDialog(): void {
    this.$store.dispatch(`explanation/closeModal`, {name: 'explanation'});
  }

  // 추천
  setUp(item: ExplanationOVO) {
    const param: RecommendationIVO = {} as RecommendationIVO;
    param.exNo = item.exNo;
    param.rmCnt = 1;
    param.caNo = this.explanation.caNo;

    axios.post('omr/recommendation', param)
    .then(r=>{
      this.explanations = r.data;
    })
  }

  // 비추천
  setDown(item: ExplanationOVO) {
    const param: RecommendationIVO = {} as RecommendationIVO;
    param.exNo = item.exNo;
    param.rmCnt = -1;
    param.caNo = this.explanation.caNo;

    axios.post('omr/recommendation', param)
    .then(r=>{
      this.explanations = r.data;
    })
  }

  // 풀이 작성 다이얼로그 오픈
  openExplanationForm(): void  {
    this.$store.dispatch(`explanationForm/openModal`, {name: 'explanationForm'})
  }

  // 오답노트 작성 다이얼로그 오픈
  openWrongAnswerMemoForm(): void {
    this.$store.dispatch(`memoForm/openModal`, {name: 'memoForm'})
  }

  // 풀이 입력 모달 watch
  changeExplanationFormModal(e) {
    if(e == false) return; 

    // 모달이 닫힐때만 실행
    this.init();
  }

  outsideClickEventHandler() {
    this.closeDialog();
  }

  escKeyDownEventHandler() {
    this.closeDialog();
  }

  // 데이터 초기화
  @Watch('$store.state.explanation.opened')
  @Watch('$store.state.explanationForm.opened')
  @Watch('$store.state.memoForm.opened')
  init(): void {
    if(this.$store.state[`explanation/opened`] == false) return; 
    if(this.$store.state[`explanationForm/opened`] == true) return; 
    
    axios.get(`omr/explanations/${this.explanation.caNo}`)
    .then(r=>{
      this.explanations = r.data;
    })

    const param = {} as MemoIVO;
    param.caNo = this.explanation.caNo;
    axios.get(`omr/memo`, {params: param})
    .then(r=>{
      this.memo = r.data;
    })
  }
}
